/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo } from "react";
import { useSelector } from "react-redux";
import store from "../../store";
import { removeActiveThreadChat } from "../redux/chatSlice";
import { MessageDetailIcon, XIcon } from "../../assets/icons/svg";
import { SUPPORT_ADMIN_IDS } from "../Helpers/common";
import { _sendChatMessage } from "../../SocketIo";
import { useChatState } from "../../hooks/useChatState";

const ThreadBoardHeader = () => {
  // const dispatch = useDispatch();
  const { authSessionUser } = useSelector((state) => state.authUserDetail);
  const isSupportAdmin = SUPPORT_ADMIN_IDS.includes(authSessionUser?.user_id);
  const {
    chatRoom,
    activeThreadChat,
    chatMessage = [],
    showPhoneSupport,
  } = useChatState();

  const activeThread = activeThreadChat?.[chatRoom];
  if (!activeThread?.id) return;

  const activeThreadMessageObj = chatMessage?.find(
    (v) => v.id === activeThread.id,
  );

  const handleRemoveActiveThreadChat = (value) => {
    store.dispatch(removeActiveThreadChat(value));
  };

  const handleCloseChat = () => {
    let chatObj = {
      senderID: authSessionUser?.user_id,
      receiverID: activeThreadMessageObj?.senderID,
      thread: true,
      parent_id: activeThreadMessageObj?.id,
      support_status: "completed",
      documentID: "phone-support",
    };
    _sendChatMessage(chatObj, "phone-support");
  };

  return (
    <>
      <div className="head px-3">
        <div className="name">Thread</div>

        <div
          className="cursor-pointer "
          onClick={() => handleRemoveActiveThreadChat(chatRoom)}
        >
          <XIcon />
        </div>
      </div>

      <div className="tab-container">
        <ul
          className="nav nav-tabs justify-content-between"
          id="myTab"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              className={"nav-link d-flex align-items-center active"}
              data-toggle="tab"
              type="button"
              role="tab"
            >
              <span className="mr-1 d-inline-flex align-items-center">
                <MessageDetailIcon
                  width={16}
                  height={16}
                  className={"flip-icon"}
                />
              </span>
              <strong>Replies</strong>
            </button>
          </li>
          {showPhoneSupport &&
            isSupportAdmin &&
            activeThreadMessageObj?.support_status !== "completed" && (
              <div
                className="d-flex justify-content-end text-orange cursor-pointer no-whitespace"
                onClick={handleCloseChat}
              >
                <span>Close Chat</span>
              </div>
            )}
        </ul>
      </div>
    </>
  );
};

export default memo(ThreadBoardHeader);
